import { ROUTE_LOGIN } from '../constants';
import { callAuthAPI, isSuccessCode } from '../utils/apiUtils';
import store from '../redux/store';

class AuthService {

  getLoggedInUserInfo() {
    return store.getState().auth.user;
  }

  async login(credentials) {
    try {
      const response = await callAuthAPI('login', credentials, 'post', true);
      console.log('AuthService.login - response:', response);
      
      if (!isSuccessCode(response.status)) {
        throw new Error('Login failed');
      }

      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  }

  async loginWithGoogle(token, turnstileToken) {
    try {
      const response = await callAuthAPI('auth/google', { token, turnstileToken }, 'post', true);
      
      if (!isSuccessCode(response.status)) {
        throw new Error('Google login failed');
      }
      
      return response.data; 
    } catch (error) {
      console.error('Google login error:', error);
      throw error;
    }
  }

  async verifyTwoFactor(payload) {
    try {
      const response = await callAuthAPI('login/verify-2fa', payload, 'post', true);
      if (!isSuccessCode(response.status)) {
        throw new Error('Verification failed');
      }
      return response.data;
    } catch (error) {
      console.error('2FA Verification error:', error);
      throw error;
    }
  }

  async validateUser() {
    try {
      const response = await callAuthAPI('validate', undefined, 'get', true);
      return response.data.user;
    } catch {
      return null;
    }
  }

  async logout(navigate) {
    return callAuthAPI('logout', {}, 'post', true)
      .then(response => {
        navigate(ROUTE_LOGIN);
        return response;
      });
  }

  async register(userData) {
    try {
      const response = await callAuthAPI('login', userData, 'post', true);
      if (!response.ok) {
        throw new Error('Registration failed');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Registration error:', error);
      throw error;
    }
  }

  hasPermission(permissionName) {
    const userInfo = this.getLoggedInUserInfo();
    if (!userInfo) return false;
    return !!userInfo?.permissions?.[permissionName];
  };

  hasEntityPermission(entityName, permissionPrefix) {
    return this.hasPermission(permissionPrefix + entityName);
  };

  getContinueWritingWordCount() {
    const userInfo = this.getLoggedInUserInfo();
    if (!userInfo) return 0;
    return userInfo.continueWritingWordCount ?? 100;
  }

  hasDashboardViewPermission() {
    return !!this.getLoggedInUserInfo();
  };
}
const authService = new AuthService();
export default authService;